import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performPostRequest } from '@atlassian/jira-fetch';
import type { SearchTeamsParams, SearchTeamsResponse } from '../../../../common/types';

export const searchTeamsEndpoint = ({ orgId, siteId, accountId }: SearchTeamsParams) => {
	const url = '/gateway/api/v4/teams/search';

	return performPostRequest<SearchTeamsResponse>(url, {
		method: 'POST',
		body: JSON.stringify({
			organizationId: orgId,
			siteId,
			membership: { memberAccountIds: [accountId] },
			sortBy: [{ field: 'displayName', order: 'asc' }],
			limit: 100,
		}),
	}).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'searchTeamsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};
